// extracted by mini-css-extract-plugin
export default {"wrapper":"gridViev_wrapper__2SbPW","inside":"gridViev_inside__F505S","element":"gridViev_element__sr84h","image":"gridViev_image__4M9vo","info":"gridViev_info__V9I7u"};